import {CardContent, styled} from '@mui/material';

const CardContentStyled = styled(CardContent)`
	background-repeat: no-repeat;
	background-size: cover;
`;

export {CardContentStyled};
